import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux";
import { createTimeslot, forceTimeslotUpdate, updateSelectCategoryPrenotation } from "../../../redux/reducer/timeslotReducer";
import AlertMessageModal from "../../alertMessageModal";
import ButtonIcon from "../../common/buttonIcon"
import ButtonSubmit from "../../common/buttonSubmit";
import ButtonWhite from "../../common/buttonWhite";
import DatePickerTimeslotMultipleDate from "../../common/datePickerTimeslotMultipleDate";
import ErrorMessageBox from "../../common/errorMessageBox";
import InputFiled from "../../common/inputFiled";
import SelectBox from "../../common/selectBox";
import TitleModal from "../../common/titleModal"
import InputFiledIcon from "../../inputFiledIcon";
import BoxEditTimeslotInterval from "./boxEditTimeslotInterval";
import { isGroupLinkChild } from "../../../utils/helpers";

const CreateTimeslot = (props: any) => {
  let date = props.date ?? new Date();
  const { categoryPrenotation } = useSelector((state: any) => state.timeslot);
  const { selectCategoryPrenotation } = useSelector((state: any) => state.timeslot);
  const [serviceSelet, setServiceSelet] = useState(selectCategoryPrenotation);
  const [timeslotTime, setTimeslotTime] = useState("minuti");
  const [timeslotTimeMode, setTimeslotTimeMode] = useState(0);
  const { rangEvent } = useSelector((state: any) => state.login);
  const dispacth = useAppDispatch();
  let dataArray: any = [];
  const [dateSelect, setDateSelect] = useState(dataArray);
  const [waitingTime, setWaitingTime] = useState("");
  const [waitingTimeEdit, setWaitingTimeEdit] = useState(0);
  const [maxAttendnace, setMaxAttendnace] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [labelSuccess, setLabelSuccess] = useState("");
  const [spinner, setSpinner] = useState(false);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let paramsService: any[] = categoryPrenotation
    .filter((c: any) => !c.disabled && !isGroupLinkChild(c.groupLink))
    .map((category: any) => ([category.name, category._id]));
  let paramWaitingTime = [
    ["15m", "15"],
    ["30m", "30"],
    ["45m", "45"],
    ["Personalizza", "-1"],
  ]
  let paramsTimeslotTime = [
    [t('minutes'), "minuti"],
    [t('hours'), "ore"]
  ]

  let timeslotAvailabilityDate = props.timeslotAvailabilityDate ?? [{ startTime: "", endTime: "" }];

  const [timeslotAvailability, setTimeslotAvailability] = useState(timeslotAvailabilityDate);

  const addTimeslotAvailability = () => {
    let array: any = Object.assign([], timeslotAvailability);
    array[timeslotAvailability.length] = { startTime: "", endTime: "" };
    setTimeslotAvailability(array);
  }
  const removeTimeslotAvailability = (id: number) => {
    let array: any = Object.assign([], timeslotAvailability);
    setTimeslotAvailability(array.filter((value: any, index: number) => index !== id));
  }

  useEffect(() => {
    var dateNow = new Date();
    dateNow.setUTCHours(0, 0, 0, 0);
    if (date >= dateNow && date >= new Date(rangEvent?.startDate) && date <= new Date(rangEvent?.endDate)) {
      setDateSelect([date]);
    }
    else {
      setDateSelect([]);
    }
    if (selectCategoryPrenotation !== "") {
      setServiceSelet(selectCategoryPrenotation);
    }
  }, [date, selectCategoryPrenotation, timeslotAvailability])

  useEffect(() => {
    setTimeslotAvailability(timeslotAvailabilityDate)
  }, [timeslotAvailabilityDate])

  const mangerEditTimeslotInterval = (value: any, id: any) => {
    if (id === (timeslotAvailability.length - 1)) {
      addTimeslotAvailability()
    }
    else {
      removeTimeslotAvailability(id)
    }
  }

  const saveTimeslot = async () => {
    setSpinner(true);
    setErrorMessage("");

    let objectSave: any = {};

    if (dateSelect.length < 1) {
      setErrorMessage(t('error.select-data'));
      setSpinner(false)
      return;
    }
    objectSave.repeatDays = dateSelect.map((date: any) => moment(date).format("YYYY-MM-DD"));;
    if (!serviceSelet) {
      setErrorMessage(t('error.select-service'));
      setSpinner(false)
      return;
    }
    objectSave.timeslotCategoryId = serviceSelet;
    objectSave.timezone = timezone;
    if (timeslotTimeMode < 1) {
      setErrorMessage(t('error.select-duration'));
      setSpinner(false)
      return;
    }
    objectSave.timeslotDuration = ((timeslotTime === "ore") ? timeslotTimeMode * 60 : timeslotTimeMode);
    objectSave.maximumAttendances = maxAttendnace;
    if (waitingTime !== "-1") {
      objectSave.timeslotInterval = waitingTime;
    }
    else {
      objectSave.timeslotInterval = waitingTimeEdit;
    }
    let timeslotAvailabilityNotEmpty = timeslotAvailability.filter((availability: any) => (availability.startTime !== "" || availability.endTime !== ""));

    if (!timeslotAvailabilityNotEmpty.length) {
      setErrorMessage(t('error.empty-timeslot-availability'));
      setSpinner(false)
      return
    }
    objectSave.timeslotAvailabilityTimetables = timeslotAvailabilityNotEmpty;
    if (maxAttendnace < 1) {
      setErrorMessage(t('error.max-attendance-minor-0'));
      setSpinner(false)
      return
    }
    const response = await dispacth(createTimeslot(objectSave));
    if (response.status === 200) {
      props.closePopUp();
      setModalSuccess(true);
      setLabelSuccess(t('success-message.CREATE_TIMESLOT'));
      resetFields();
      dispacth(forceTimeslotUpdate())
    }
    else {
      setErrorMessage(response.data?.error ?? t('error.generic'));
      console.log("Data Error", response.data?.error);
    }
    setSpinner(false)

  }
  const resetFields = () => {
    setTimeslotTimeMode(0)
    setTimeslotTime("minuti");
    setWaitingTime("");
    setTimeslotAvailability([{ startTime: "null", endTime: "null" }])
    setErrorMessage("");
    setMaxAttendnace(1);
  }

  const closePopUp = () => {
    resetFields();
    props.closePopUp();
  }
  return (
    <>
      <div className="col-lg-12 p-4">
        <div className="TitleHeader">
          <div className="row m-0">
            <div className="col-10 p-0 text-left">
              <h6 className="pt-1">{t('popup-timeslot-create.label-create') as String}</h6>
            </div>
            <div className="col-2">
              <ButtonIcon handleClick={closePopUp} icon="close" />
            </div>
          </div>
        </div>
        <div className="Body">
          <TitleModal title={t('popup-timeslot-create.label-select-service')} />
          <SelectBox handleChange={setServiceSelet} value={serviceSelet} params={paramsService} firstSelect='Seleziona' />
          <TitleModal title={t('popup-timeslot-create.label-duration')} />
          <div className="row">
            <div className="col-lg-5">
              <InputFiled type="number" value={timeslotTimeMode} name="numberWaitTime" handleChange={setTimeslotTimeMode} />
            </div>
            <div className="col-lg-5">
              <SelectBox handleChange={setTimeslotTime} value={timeslotTime} params={paramsTimeslotTime} />

            </div>
          </div>
          <TitleModal title={t('popup-timeslot-create.label-interval')} />
          <BoxEditTimeslotInterval handelClick={mangerEditTimeslotInterval} timeslotAvailability={timeslotAvailability} />

          <TitleModal title={t('popup-timeslot-create.label-wait-time')} />
          <SelectBox handleChange={setWaitingTime} value={waitingTime} params={paramWaitingTime} firstSelect='Nessuna' />
          {((waitingTime === "-1") ?
            <>
              <TitleModal title={t('label-insert-interval')} />
              <InputFiled type="number" value={waitingTimeEdit} name="numberWaitTime" handleChange={setWaitingTimeEdit} />
            </>
            : <></>)}
          <TitleModal title={t('label-select-day-service')} />
          <DatePickerTimeslotMultipleDate minDate={rangEvent?.startDate} maxDate={rangEvent?.endDate} date={dateSelect} handleChange={(setDateSelect)} />

          <TitleModal title={t('label-max-attendnace')} />
          <InputFiledIcon type="number" name="numberMaxAttendnace" handleChange={setMaxAttendnace} value={maxAttendnace} icon="boy" />
          <ErrorMessageBox errorMessage={errorMessage} />
        </div>
        <div className="Body pt-3 text-lg-right">
          <ButtonWhite textButton={t("cancel")} handleChange={closePopUp} />
          <ButtonSubmit spinner={spinner} textButton={t('save')} handleChange={saveTimeslot} />
        </div>
      </div>
      <AlertMessageModal
        description={<p>{labelSuccess}</p>}
        closeModal={() => (setModalSuccess(false))}
        errorMessage={errorMessage}
        show={modalSuccess} />
    </>
  )
}

export default CreateTimeslot